// Importar as fontes diretamente
import GTHaptikRegular from './gt-haptik/GT-Haptik-Regular.otf'
import GTHaptikLight from './gt-haptik/GT-Haptik-Light.otf'
import GTHaptikMedium from './gt-haptik/GT-Haptik-Medium.otf'
import GTHaptikBold from './gt-haptik/GT-Haptik-Bold.otf'

export const fontStyles = `
  @font-face {
    font-family: 'GT Haptik';
    src: url('${GTHaptikRegular}') format('opentype');
    font-weight: 400;
    font-style: normal;
  }

  @font-face {
    font-family: 'GT Haptik';
    src: url('${GTHaptikLight}') format('opentype');
    font-weight: 300;
    font-style: normal;
  }

  @font-face {
    font-family: 'GT Haptik';
    src: url('${GTHaptikMedium}') format('opentype');
    font-weight: 500;
    font-style: normal;
  }

  @font-face {
    font-family: 'GT Haptik';
    src: url('${GTHaptikBold}') format('opentype');
    font-weight: 700;
    font-style: normal;
  }
`;